import { css } from '@emotion/css';
import React from 'react';
import { ReactComponent as WaveMini } from '../../assets/images/wave-cover/bg_wave_mini.svg';
import { ReactComponent as WavePhone } from '../../assets/images/wave-cover/bg_wave_phone.svg';
import { ReactComponent as WaveTablet } from '../../assets/images/wave-cover/bg_wave_tablet.svg';

export const WaveCover: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  return (
    <div
      className={css`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
      `}
      style={style}
    >
      {(() => {
        if (window.matchMedia('(min-width: 640px)').matches) {
          return <WaveTablet />;
        } else if (window.matchMedia('(min-width: 370px)').matches) {
          return <WavePhone />;
        } else {
          return <WaveMini />;
        }
      })()}
    </div>
  );
};
